import { FC, useState, ChangeEvent, useEffect } from "react";
import { InputBox } from "./Input.styled";

export interface TextDataInfo {
  value?: string | number;
}

type Props = {
  value: TextDataInfo;
  onChange: (value: string) => void;
  type: "text" | "number";
  min?: number;
  max?: number;
  className?: string;
  triggerToUpdate?: boolean;
};

export const Input: FC<Props> = ({
  value,
  onChange,
  type,
  min,
  max,
  className,
  triggerToUpdate,
}) => {
  const [inputValue, setInputValue] = useState(value.value);

  const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    onChange(e.target.value);
  };

  useEffect(() => {
    setInputValue(value.value);
  }, [triggerToUpdate, value.value]);

  return (
    <InputBox
      className={className}
      type={type}
      value={inputValue}
      onChange={onChangeInput}
      placeholder="Add smth.."
      min={min}
      max={max}
    />
  );
};
